import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import useGetLink from "../../../hooks/other/useGetLink";
import { useAppSelector } from "../../../store/index.ts";

export default function LinksFooter() {
  const { t } = useTranslation();
  const isWagerGames = useAppSelector((state) => state.games.categoryWager?.id);
  const isHitGames = useAppSelector((state) => state.games.hitGames?.length);

  const providers = useGetLink("/games/providers");
  const wager = useGetLink("/wager_games");
  const hit = useGetLink("/games/hit");
  const all = useGetLink("/games/all");
  const terms = useGetLink("/terms");

  return (
    <div className="footer__content__contents__items">
      <Link to={providers}>{t("All providers")}</Link>
      {!!isWagerGames && <Link to={wager}>{t("Wager games")}</Link>}
      {!!isHitGames && <Link to={hit}>{t("Hit")}</Link>}
      <Link to={all}>{t("All games")}</Link>
      <Link to={terms}>{t("Usage agreement")}</Link>
    </div>
  );
}
